<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Gestantes e Puérperas"
            description="Acompanhamento integral da gestante"
            url="/esf-eap"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import ProblemasAtivos from '@/components/icons/IndicadoresAps/PreNatal/ProblemasAtivos.vue'
import TresIndicadoresPreNatal from '@/components/icons/IndicadoresAps/PreNatal/TresIndicadoresPreNatal.vue'
import ConsultasOdontologicas from '@/components/icons/IndicadoresAps/PreNatal/ConsultasOdontologicas.vue'
import ExamesHivSifilis from '@/components/icons/IndicadoresAps/PreNatal/ExamesHivSifilis.vue'
import ConsultasPreNatal from '@/components/icons/IndicadoresAps/PreNatal/ConsultasPreNatal.vue'

export default {
  name: 'PreNatal',
  components: {
    Menu,
    Footer,
    SectionTitle,
    ProblemasAtivos,
    TresIndicadoresPreNatal,
    ConsultasOdontologicas,
    ExamesHivSifilis,
    ConsultasPreNatal,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.pre_natal
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
